// MetadataBadges.js (Refactored to use <ResourceBadges /> and centralized styles)
import React from 'react';
import ResourceBadges from '../Badges/ResourceBadges';
import { Hash } from 'lucide-react';

/**
 * Tooltip wrapper with fade effect
 */
const Tooltip = ({ text, children }) => (
  <div className="relative group cursor-pointer">
    {children}
    <div className="absolute z-10 bottom-full mb-1 left-1/2 -translate-x-1/2 px-2 py-1 text-xs text-white bg-gray-700 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200">
      {text}
    </div>
  </div>
);

/**
 * Badge-style icon with hash and digit text for English
 */
export const EnglishDigitIcon = () => (
  <Tooltip text="English Digits">
    <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200 shadow-sm group-hover:scale-105 transition-transform duration-200">
      <Hash className="w-3.5 h-3.5 text-blue-700" aria-hidden="true" />
      <span className="font-semibold">1 2</span>
    </span>
  </Tooltip>
);

/**
 * Badge-style icon with hash and Devanagari digits for Marathi
 */
export const MarathiDigitIcon = () => (
  <Tooltip text="Marathi Digits">
    <span className="inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800 border border-blue-200 shadow-sm group-hover:scale-105 transition-transform duration-200">
      <Hash className="w-3.5 h-3.5 text-blue-700" aria-hidden="true" />
      <span className="font-semibold font-[\'Noto Sans Devanagari\',Mangal,serif]">१ २</span>
    </span>
  </Tooltip>
);

const MetadataBadges = ({ resource }) => {
  const language = resource.language;

  return (
    <div className="flex flex-wrap justify-start gap-x-1 gap-y-1 mt-1 -ml-0.5 items-center">
      <ResourceBadges resource={resource} />
      {language === 'English' && <EnglishDigitIcon />}
      {language === 'Marathi' && <MarathiDigitIcon />}
    </div>
  );
};


export default MetadataBadges;
